<div *ngIf="this.forgotPasawordStatus==1">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow" >
            <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
            ¿Olvidaste tu contraseña?
        </div>
    </div>
    <div>
        <div class="basicrow m-top-i">
            <label class="label-f">Correo Electrónico</label>
            <div class="basicrow">
                <input type="email" placeholder="" (keypress)="this.global.validateInputKey($event)"
                    (blur)="this.global.validateInputKey($event)" class="inp-f" required [formControl]="emailF"
                    id="emailF" class="inp-f">
                <div *ngIf="emailF.invalid && (emailF.dirty || emailF.touched)"
                    class="alert alert-danger">
                    <div *ngIf="emailF.errors.required">
                        Email Requerido.
                    </div>
                    <div *ngIf="emailF.errors.email">
                        Por favor introduzca una dirección de correo electrónico válida
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <a (click)="this.validarUser2();" class="btns red vcenter">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>